module.exports = __webpack_public_path__ + "img/portfolio-10.54443462.png";